import { awaitTo, downFile } from '@/utils/utils';

import { useStateUtils } from '@/utils/deviceUtils/utils';
import { mergeWith } from 'lodash';
import { toTimestamp } from '@/utils/date';

export const cfrSampleStatusUtils = useStateUtils({
  namespace: 'cottonResult',
  options: [
    { state: 0, text: '初始' },
    { state: 1, text: '本底采样中' },
    { state: 2, text: '进样中' },
    { state: 3, text: '本底采样完成' },
    { state: 4, text: '进样完成' },
    { state: 5, text: '筛选完成' }
  ]
});

export const cfrBtnUtils = useStateUtils({
  namespace: 'cottonResult',
  options: [
    { state: -1, text: '加载中' },
    { state: 0, text: '开始采本底', color: '#00ffff', sampleType: 1, type: 1, afterStatus: 1 },
    { state: 1, text: '结束采本底', color: '#00ffff', sampleType: 1, type: 0, afterStatus: 3 },
    { state: 2, text: '结束进样', color: '#ffff00', sampleType: 2, type: 0, afterStatus: 4 },
    { state: 3, text: '开始进样', color: '#ffff00', sampleType: 2, type: 1, afterStatus: 2 },
    { state: 4, text: '保存' },
    { state: 5, text: '已完成' }
  ]
});

export const matUitls = useStateUtils({
  name: 'mat',
  options: [
    { label: '有毒有害气体', value: 0 },
    { label: '化学战剂', value: 1 }
  ],
  config: {
    state: 'value',
    text: 'label'
  }
});

export const matOptions = [
  { label: '有毒有害气体', value: 0 },
  { label: '化学战剂', value: 1 }
];

export const sampleMap = {
  1: 1,
  3: 1,
  2: 2,
  4: 2,
  5: 5
};

const handleIcon =
  'M10.7,11.9H9.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4h1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7v-1.2h6.6z M13.3,22H6.7v-1.2h6.6z M13.3,19.6H6.7v-1.2h6.6z';

export function makeLine(options) {
  return mergeWith(
    {
      color: [
        '#ff0000',
        '#ff5e00',
        '#ffbf00',
        '#e1ff00',
        '#80ff00',
        '#22ff00',
        '#00ff40',
        '#00ff9d',
        '#00ffff',
        '#00a2ff',
        '#0040ff',
        '#1e00ff',
        '#8000ff',
        '#dd00ff',
        '#ff00bf',
        '#ff0062'
      ],
      tooltip: {
        trigger: 'axis',
        position: (point, _params, _dom, _rect, size) => {
          // 假设自定义的tooltips尺寸
          const box = [170, 170];
          // 偏移
          const offsetX = point[0] < size.viewSize[0] / 2 ? 20 : -box[0] - 20;
          const offsetY = point[1] < size.viewSize[1] / 2 ? 20 : -box[1] - 20;
          const x = point[0] + offsetX;
          const y = point[1] + offsetY;

          const maxOffsetX = size.viewSize[0] - size.contentSize[0];
          const maxOffsetY = size.viewSize[1] - size.contentSize[1];

          return [Math.min(maxOffsetX, x), Math.min(maxOffsetY, y)];
        },
        show: true
      },
      toolbox: {
        show: true,
        left: 0,
        iconStyle: {
          borderColor: '#fff',
          color: '#fff'
        },
        feature: {
          myTool1: {
            show: true,
            title: '全选',
            icon: 'path:M412.16 738.304a51.2 51.2 0 0 1 0 69.12l-3.072 3.328L210.432 998.4a51.2 51.2 0 0 1-67.072 2.816L140.032 998.4 16.384 880.64a51.2 51.2 0 0 1 67.072-76.8l3.328 2.816 88.832 84.224 164.096-153.6a51.2 51.2 0 0 1 72.448 2.304zM972.8 824.576a51.2 51.2 0 0 1 0 102.4H563.2a51.2 51.2 0 0 1 0-102.4zM412.16 379.904a51.2 51.2 0 0 1 0 69.376l-3.072 3.072L210.432 640a51.2 51.2 0 0 1-67.072 2.816L140.032 640 16.384 522.24a51.2 51.2 0 0 1 67.072-76.8l3.328 2.816 88.832 84.48 164.096-153.6a51.2 51.2 0 0 1 72.448 2.048zM972.8 466.176a51.2 51.2 0 0 1 0 102.4H563.2a51.2 51.2 0 0 1 0-102.4zM412.16 21.76a51.2 51.2 0 0 1 0 69.12l-2.56 3.072L210.432 281.6a51.2 51.2 0 0 1-67.072 2.816L140.032 281.6 16.384 163.84a51.2 51.2 0 0 1 67.072-76.8l3.328 3.072L175.616 174.08l164.096-153.6a51.2 51.2 0 0 1 72.448 1.28zM972.8 108.032a51.2 51.2 0 0 1 44.288 76.8 51.2 51.2 0 0 1-44.288 25.6H563.2a51.2 51.2 0 0 1-44.288-25.6 51.2 51.2 0 0 1 44.288-76.8z m0 0',
            onclick: function (_, e) {
              e.dispatchAction({
                type: 'legendAllSelect'
              });
            }
          },
          myTool2: {
            show: true,
            title: '全不选',
            icon: 'path:M977.934545 124.014545c0 31.99999969-27.78181781 58.64727281-61.09090875 58.64727281H416.77090906c-33.30909094 0-66.6472725-26.64727312-66.6472725-58.64727281s27.78181781-58.64727281 61.09090875-58.64727188h494.45818219C944.59636344 60.04363625 977.934545 86.69090937 977.934545 124.014545z m0 373.23636375c0 31.99999969-27.78181781 58.64727281-61.09090875 58.64727281H416.77090906c-33.30909094 0-61.09090875-26.67636375-61.09090875-58.64727281 0-31.99999969 27.78181781-58.67636344 61.09090875-58.67636344h494.45818219c38.89454531 0 66.67636406 26.67636375 66.67636312 58.67636344z m-5.55636281 373.20727313c0 31.99999969-27.78181781 58.64727281-61.09090969 58.64727281H411.24363594c-33.30909094 0-61.09090875-26.64727312-61.09090875-58.64727281s27.78181781-58.64727281 61.09090875-58.64727282h494.45818218c38.89454531 0 66.67636406 26.64727312 66.67636407 58.64727282z m-763.37454563-20.47999969l72 72a29.09090906 29.09090906 0 0 1-41.16363656 41.134545l-72-71.97090938-71.97090938 71.97090938a29.09090906 29.09090906 0 1 1-41.16363562-41.134545l72-72-72-72A29.09090906 29.09090906 0 1 1 95.89818219 736.87272687l71.97090843 72 72-72a29.09090906 29.09090906 0 0 1 41.16363657 41.13454594l-72 72z m0-349.09090969l72 72a29.09090906 29.09090906 0 0 1-41.16363656 41.13454594l-72-71.97090938-71.97090938 71.97090938a29.09090906 29.09090906 0 1 1-41.16363562-41.13454594l72-72-72-72A29.09090906 29.09090906 0 1 1 95.89818219 387.78181813l71.97090843 71.99999999 72-72a29.09090906 29.09090906 0 0 1 41.16363657 41.13454594l-72 72z m0-339.1418175l72 72a29.09090906 29.09090906 0 0 1-41.16363656 41.134545L167.84 202.88 95.89818219 274.90909062A29.09090906 29.09090906 0 0 1 54.705455 233.745455L126.73454563 161.745455 54.705455 89.745455A29.09090906 29.09090906 0 0 1 95.89818219 48.61090906l71.97090843 72L239.84 48.58181844a29.09090906 29.09090906 0 1 1 41.16363656 41.134545L209.00363656 161.745455z',
            onclick: function (_, e) {
              e.dispatchAction({
                type: 'legendAllSelect'
              });

              e.dispatchAction({
                type: 'legendInverseSelect'
              });
            }
          },
          myTool3: {
            show: true,
            title: '反选',
            icon: 'path:M305.11817 263.481576A260.228717 260.228717 0 0 1 420.919949 26.673443a281.047014 281.047014 0 0 0-249.168996 236.808133H81.321474l158.088945 150.932655 158.739517-150.932655zM534.119441 0h477.519695v441.087675H534.119441zM12.360864 1024h478.170267V584.213469H12.360864z m77.418043-363.01906h325.285896v286.90216h-325.285896z',
            onclick: function (_, e) {
              e.dispatchAction({
                type: 'legendInverseSelect'
              });
            }
          }
        }
      },
      dataZoom: [
        {
          id: 'xSlider',
          name: 'xSlider',
          handleIcon: handleIcon,
          borderColor: '#04d7ff',
          fillerColor: 'rgba(255,255,255,0.2)',
          show: false,
          start: 0,
          end: 100,
          minSpan: 10,
          textStyle: {
            color: '#fff'
          }
        }
      ],
      grid: {
        left: 210,
        right: 30,
        top: 30,
        bottom: 30
      },
      legend: {
        orient: 'vertical',
        top: 35,
        left: '0%',
        icon: 'roundRect',
        textStyle: {
          color: '#fff'
        }
      },
      xAxis: {
        type: 'time',
        splitLine: {
          show: false,
          lineStyle: {
            color: '#283763'
          }
        },
        axisLine: {
          lineStyle: {
            color: '#04d7ff'
          }
        }
      },
      yAxis: {
        type: 'value',
        max(v) {
          if (v.max > 0) {
            return Math.ceil((v.max * 12) / 10);
          } else if (v.max === 0) {
            return v.max + 0.0001;
          } else {
            return Math.ceil((v.max * 8) / 10);
          }
        },
        splitLine: {
          show: false
        },
        axisLine: {
          lineStyle: {
            color: '#04d7ff'
          }
        }
      },
      dataset: {
        source: [],
        dimensions: []
      },
      series: []
    },
    options
  );
}

const dimensions = [
  'time',
  'ecHclValue',
  'ecSo2Value',
  'ecCoValue',
  'ecCh4Value',
  'ecPidValue',
  'ecBenValue'
];

const dimensionsZh = ['时间', 'hcl值', 'so2值', 'co值', 'ch4值', 'pid值', 'ben值'];

export function makeSensorOpts() {
  return makeLine({
    color: ['#ff0000', '#00ff00', '#0000ff', '#ffff00', '#ff00ff', '#00ffff'],
    dataset: {
      dimensions: dimensions.map((_, i) => i),
      source: []
    },
    series: dimensionsZh.slice(1).map((e, i) => ({
      name: e,
      type: 'line',
      showSymbol: false,
      encode: {
        x: 0,
        y: i + 1
      },
      markLine: {
        data: []
      }
    }))
  });
}

export function makeChannelOpts() {
  const dimensions = Array(17)
    .fill()
    .map((_, i) => i);

  return makeLine({
    dataset: {
      dimensions,
      source: []
    },
    grid: {
      bottom: 62
    },
    dataZoom: [{ show: true }],
    series: dimensions.slice(1).map((_, i) => ({
      name: `通道 ${i + 1}`,
      type: 'line',
      showSymbol: false,
      encode: { x: 0, y: i + 1 },
      markLine: {
        data: []
      }
    }))
  });
}

const precision = 4;

export function parseChartData(data) {
  try {
    const ims = [];
    const sensors = [];

    const getData = item => {
      const arr = [];

      dimensions.forEach(key => {
        arr.push(+Number(item[key]).toFixed(precision));
      });

      return arr;
    };

    const record = [];

    data.forEach(e => {
      const time = toTimestamp(e.time);
      if (record.includes(time)) return;

      record.push(time);

      const imsVal = e.cwaIms.split(',').map(item => +Number(item).toFixed(precision));

      ims.push([time, ...imsVal]);
      sensors.push(getData({ ...e, time }));
    });

    return {
      imsData: ims,
      sensorsData: sensors
    };
  } catch (error) {
    console.log('数据错误无法解析', error);
    return {
      imsData: [],
      sensorsData: []
    };
  }
}

export function parseRealTimeChartData(data) {
  const { beginTime, mods } = data;
  const { hcl, so2, co, ch4, pid, ben } = mods.ecMod;
  const { ims } = mods.cwaMod;

  const sensorsData = {};
  const imsData = {};

  const arr = [beginTime, hcl, so2, co, ch4, pid, ben];

  arr.forEach((e, i) => {
    if (!sensorsData[beginTime]) sensorsData[beginTime] = [];

    const v = i === 0 ? e : e?.value;

    sensorsData[beginTime].push(+Number(v).toFixed(precision));
  });

  const imsVal = ims.map(e => +Number(e).toFixed(precision));

  imsData[beginTime] = [beginTime, ...imsVal];

  return {
    sensorsData,
    imsData
  };
}

export const makeTableConfig = () => {
  // <MTable
  //       :i18nPath="i18nPath"
  //       :loading="loading"
  //       :tableData="tableData"
  //       :tableColumn="tableColumn"
  //       :hasPagination="false"
  //       style="width: 100%"
  //       height="calc(90vh - 160px)"
  //       v-on:search="getSampleList"
  //     ></MTable>
  //  makeTable(data) {
  //     const { dimensions, dimensionsZh, sampleData } = data;

  //     this.tableColumn = dimensions.map((e, i) => ({
  //       prop: e,
  //       label: dimensionsZh[i],
  //       width: 'auto'
  //     }));

  //     this.tableData = sampleData;
  //   },
  return {
    i18nPath: '',
    tableData: [],
    tableColumn: [],
    oprateMenu: {
      label: '操作',
      list: [
        {
          text: '下载',
          access: () => true,
          event: async (_index, data, loading) => {
            const btn = loading();

            btn.open();

            await downFile(
              {
                url: '/fcbrMatLibrary/exportSampleData',
                method: 'get',
                params: {
                  id: data.id,
                  sn: this.sn,
                  sampleType: 5
                }
              },
              `采样_${this.sn}_${data.id}.xlsx`
            );

            btn.close();
          }
        },
        {
          text: '重置采样',
          access: () => true,
          event: async (_index, data, loading) => {
            const btn = loading();

            btn.open();

            const [err, res] = await awaitTo(
              this.$confirm('确认删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              })
            );

            if (err || res !== 'confirm') return btn.close();

            await this.delSample(data.id);

            btn.close();
          }
        }
      ]
    }
  };
};
